<template>
    <div class="order-detail-section mg20" v-if="order">
        <h3>原来合同附件：</h3>
        <div class="userInfo-wrapper">
            <el-row class="userInfo-group">
                合同编号：{{order.contract_number}}
            </el-row>
            <el-row class="userInfo-group" v-for="item in order.contracts" :key="item.id">
                <el-row>
                    <el-col :span="12" class="order-item">合同名：<a :href="item.url" target="_blank"><i
                            class="el-icon-document"></i>{{item.name}}</a></el-col>
                </el-row>
            </el-row>
        </div>
    </div>
</template>

<script>
    export default {
        name: "order_origin_contract",
        props: {
            order: {
                required:false
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/order/partial/order_origin_contract.vue